import clsx from 'clsx';

type ModalSize = 'sm' | 'md' | 'lg';

interface ModalPanelProps {
  title: string;
  children: React.ReactNode;
  size: ModalSize;
  onClose: () => void;
}

const sizeClasses: Record<ModalSize, string> = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
};

export function ModalPanel({ title, children, size, onClose }: ModalPanelProps) {
  return (
    <div className={clsx('relative bg-white rounded-lg shadow-xl w-full mx-4 flex flex-col max-h-[90vh]', sizeClasses[size])}>
      <div className="flex-none flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <h3 id="modal-title" className="text-lg font-semibold text-gray-900">{title}</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="閉じる"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-6 py-4">{children}</div>
    </div>
  );
}
